import React, { Children } from 'react';
import { MenuContext } from './MenuContext';
import { MenuItem } from './MenuItem';
import { PopoverContext } from './PopoverProvider';
import { useMenu } from './useMenu';
export const MenuProvider = ({ children }) => {
    const { popoverProps } = React.useContext(PopoverContext);
    // First child is PopoverInner, then the next child is a single Menu with MenuItem children
    // React.Children.toArray flattens the array to deal with any React.Fragment that might be wrapped around the MenuItems
    const menuItemChildrenArray = React.Children.toArray(Array.isArray(children) ? children[0]?.props?.children?.props?.children : []);
    const { isOpen, onClose, setIsOpen } = popoverProps ?? {};
    const { getMenuProps, getItemProps, getTriggerProps, highlightedIndex } = useMenu({
        isOpen: isOpen ?? false,
        setIsOpen: (isOpen) => {
            if (onClose) {
                onClose(isOpen);
            }
            if (setIsOpen) {
                setIsOpen(isOpen);
            }
        },
        totalItems: Children.count(menuItemChildrenArray),
        isItemDisabled: (index) => {
            if (Array.isArray(menuItemChildrenArray)) {
                const currentChild = menuItemChildrenArray[index];
                return currentChild?.props?.disabled || currentChild?.type !== MenuItem;
            }
        },
    });
    return (React.createElement(MenuContext.Provider, { value: { getMenuProps, getItemProps, getMenuTriggerProps: getTriggerProps, highlightedIndex } }, children));
};
